import { useState } from "react";
import { Rail } from "./Rail";
import { GlowBackdrop as Glow } from "./GlowBackdrop";
import { DOCUMENTS, NUMBER_WORDS } from "@/lib/business";

export const Documents = () => {
  const [active, setActive] = useState("Anmeldung");
  const docs = DOCUMENTS[active];
  return (
    <Rail id="unterlagen" label="01 · Was Sie mitbringen" labelClass="text-white/80" className="shade-plate text-white relative isolate overflow-hidden">
      <Glow />
      <h2 className="dp pc-h2 [text-shadow:0_8px_30px_rgba(15,31,56,0.45)]" data-testid="documents-headline">
        {NUMBER_WORDS[docs.length]} Unterlagen. Fertig.
      </h2>
      <div className="mt-6 sm:mt-8 -mx-5 px-5 sm:mx-0 sm:px-0 overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
      <div className="inline-flex sm:flex-wrap gap-1 rounded-full border border-white/20 bg-white/10 p-1 backdrop-blur-md shadow-[0_10px_30px_-12px_rgba(15,31,56,0.5)]" role="tablist">
        {Object.keys(DOCUMENTS).map((key) => (
          <button
            key={key}
            type="button"
            role="tab"
            aria-selected={active === key}
            onClick={() => setActive(key)}
            className={`lb whitespace-nowrap rounded-full px-3.5 sm:px-4 py-2 text-[11px] sm:text-xs transition-colors ${
              active === key ? "bg-white text-plate shadow-md" : "text-white/85 hover:bg-white/15"
            }`}
            data-testid={`documents-tab-${key.toLowerCase()}`}
          >
            {key}
          </button>
        ))}
      </div>
      </div>
      <ol key={active} className="st mt-8 sm:mt-12 grid sm:grid-cols-2 gap-2.5 sm:gap-4" data-testid="documents-list">
        {docs.map((d, i) => (
          <li
            key={d}
            className="group flex items-center gap-4 sm:gap-5 rounded-xl border border-white/20 bg-white/10 px-4 py-3 sm:px-6 sm:py-5 backdrop-blur-md shadow-[0_18px_40px_-24px_rgba(15,31,56,0.7)] transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-white/[0.16]"
          >
            <span className="dp tn text-3xl sm:text-5xl leading-none w-6 sm:w-auto text-center text-white/90 [text-shadow:0_6px_20px_rgba(15,31,56,0.5)]">{i + 1}</span>
            <span className="font-semibold text-[15px] sm:text-base leading-snug">{d}</span>
          </li>
        ))}
      </ol>
      <p className="mt-8 sm:mt-10 text-sm sm:text-base text-white/80 max-w-xl">
        Unsicher, was bei Ihnen fehlt? Schreiben Sie mir kurz – ich sage Ihnen genau, was ich brauche.
      </p>
    </Rail>
  );
};
